// function takes an array of objects and an object or array of objects to merge by id or add them
// if they don't exist in the array

export function mergeById(
  arr: Array<Partial<{ id: string }>>,
  obj: Array<Partial<{ id: string }>> | Partial<{ id: string }>
): any[] {
  if (Array.isArray(obj)) {
    obj.forEach((o) => {
      const index = arr.findIndex((a) => a.id === o.id);
      if (index > -1) {
        arr[index] = o;
      } else {
        arr.push(o);
      }
    });
  } else {
    const index = arr.findIndex((a) => a.id === obj.id);
    if (index > -1) {
      arr[index] = obj;
    } else {
      arr.push(obj);
    }
  }

  return arr;
}
